;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { FieldValues, Path, UseFormSetError } from 'react-hook-form'

export const LIMITS = {
  nameMin: 2,
  companyMin: 2,
  domainMin: 4,
  domainMax: 32,
  phoneMax: 128,
  passwordMin: 8,
} as const

export const requestJson = async <T = unknown>(path: string, options: RequestInit): Promise<T> => {
  const response = await fetch(`/api/${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  })

  const contentType = response.headers.get('content-type') ?? ''
  const isJson = contentType.includes('application/json')
  const data = isJson ? await response.json().catch(() => ({})) : await response.text()

  if (!response.ok) {
    // Without the status fallback a JSON error body that lacks `message` would produce an Error
    // with an empty message, which is what Sentry/PostHog exception capture ends up recording.
    const message = typeof data === 'string' && data ? data : (data?.message ?? `HTTP ${response.status}`)
    const error = new Error(message)
    ;(error as Error & { status?: number; data?: unknown }).status = response.status
    ;(error as Error & { status?: number; data?: unknown }).data = data
    throw error
  }

  return data as T
}

export const applyApiErrors = <T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  setMessage: (message: string | null) => void,
  fallback: string,
) => {
  const response = error as Error & { status?: number; data?: { message?: unknown; errors?: Record<string, unknown> } }
  const status = response?.status
  const data = response?.data

  if (status === 422 && data?.errors && typeof data.errors === 'object') {
    Object.entries(data.errors).forEach(([field, messages]) => {
      const message = Array.isArray(messages) ? messages[0] : messages
      if (typeof message === 'string') {
        setError(field as Path<T>, { message })
      }
    })
    setMessage(null)
    return
  }

  setMessage(typeof data?.message === 'string' ? data.message : fallback)
}

export const createSlug = (value: string) =>
  value
    .trim()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
